import { ServicesContainer } from '@/services';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AnalyticsError, AnalyticsEventType, WebPageDetails } from '../models';
import { AdobePageLoadEvent } from './adobe-page-load';

export class AdobePageNotFoundEvent extends AdobePageLoadEvent {
    event = AnalyticsEventType.PageLoaded;
    error = { errors: { value: 1 } } as AnalyticsError;
  
    constructor(store: Store<AppState>, services: ServicesContainer) {
      super(store, services);
      this.error.errorName = 'Page Not Found';
      this.web.webPageDetails = this.overrideObject({errorPage: '404 Error Page'} as WebPageDetails);
    }
  }